import { createContext, useContext } from "react";

import { type BaseObject } from "../../../evidence/base";
import { useFormContext } from "../../form/context/form-context";
import {
  type DataFormContextType,
  type UseDataFormContextResult,
} from "./types";

export const DataFormContext = createContext<DataFormContextType<any, any>>(
  null as never,
);

export function useDataFormContext<
  TData extends TFieldValues,
  TFieldValues extends BaseObject,
>(): UseDataFormContextResult<TData, TFieldValues> {
  const formContext = useFormContext<TFieldValues>();

  const context =
    useContext<DataFormContextType<TData, TFieldValues>>(DataFormContext);

  if (!context) {
    throw new Error("useDataFormContext must be used within a DataFormContext");
  }

  return {
    ...formContext,
    ...context,
  };
}
